import * as React from "react"
import Button, { ButtonProps } from "@material-ui/core/Button"
import styled from "styled-components"

export const ErrorButton = styled(Button)`
  color: #d62067 !important;
` as React.FC<ButtonProps>
